import {
  GET_TOGGLE_RIGHT_SIDE_BAR,
  SET_TOGGLE_RIGHT_SIDE_BAR,
} from "./actionType";
// initisal state
const initialState = {
  toggleRightSideBar: false,
};
const RightSidebar = (state = initialState, action) => {
  switch (action.type) {
    case GET_TOGGLE_RIGHT_SIDE_BAR:
      return {
        ...state,
      };
    case SET_TOGGLE_RIGHT_SIDE_BAR:
      return {
        ...state,
        toggleRightSideBar: action.payload,
      };
    default:
      return state;
  }
};

export default RightSidebar;
